module.exports = __webpack_public_path__ + "img/voucherAdd.15ba689e.png";